export enum PermissionType {
  Client,
  Vehicle,
  Asset,
  Contract,
  Operation,
  Invoice,
  Payment,
  Notice,
  Memory,
  Audit,
  Contribution,
  provision,
  OpenContracts,
  ClosedContracts,
  Permissions,
  Reports,
  ViewHomeCredit,
  SalesAdmin
}
